/** One sub-processor AnyAPI relies on, described the way a data protection
 *  reviewer needs to read it. This module is the only owner of the list: the
 *  Privacy Policy narrates it and the Data Processing Addendum tabulates it,
 *  and neither is allowed a second copy that can drift from the other. */
export interface Subprocessor {
  name: string;
  /** What it does for us, in the customer's words. */
  purpose: string;
  /** Where it processes what we send it. */
  location: string;
  /** True when it can process Customer Data (request parameters and retrieved
   *  data). False means it only ever sees account, billing, or website data,
   *  for which AnyAPI is the controller and the Privacy Policy governs. */
  customerData: boolean;
}

export const SUBPROCESSORS: Subprocessor[] = [
  {
    name: 'Microsoft Azure',
    purpose: 'Gateway compute, the request database, stored response bodies, and secret storage',
    location: 'United States',
    customerData: true,
  },
  {
    name: 'Cloudflare',
    purpose: 'Website and gateway delivery, caching, and denial-of-service protection',
    location: 'Global edge network, with our origin in the United States',
    customerData: true,
  },
  {
    name: 'Clerk',
    purpose: 'Account authentication and sign-in',
    location: 'United States',
    customerData: false,
  },
  {
    name: 'Autumn',
    purpose: 'Wallet billing and subscription records',
    location: 'United States',
    customerData: false,
  },
  {
    name: 'Stripe',
    purpose: 'Payment processing for wallet top-ups, behind Autumn',
    location: 'United States',
    customerData: false,
  },
  {
    name: 'PostHog',
    purpose: 'Product analytics and session replay on our websites and dashboard',
    location: 'United States',
    customerData: false,
  },
];

/** The sub-processors that can touch Customer Data, for the addendum's Annex B. */
export const customerDataSubprocessors = (): Subprocessor[] =>
  SUBPROCESSORS.filter((s) => s.customerData);

/** The rest: sub-processors of account, billing, and website data only. */
export const accountDataSubprocessors = (): Subprocessor[] =>
  SUBPROCESSORS.filter((s) => !s.customerData);
